import { AgGridReact, AgGridColumn } from "ag-grid-react";
import "../details.css";

export default function KeyExectives(props) {
  const values = props.values?.holdings ? props.values?.holdings : [];
  const t = props.t;
  return (
    <div
      style={{
        marginTop: "40px",
        display: "flex",
        justifyContent: "center",
        marginBottom: "30px",
      }}
    >
      <div
        style={{
          height: (values?.length + 2) * 41,
          width: 550,
        }}
        className="ag-theme-alpine invisible-scrollbar"
      >
        <AgGridReact
          defaultColDef={{
            sortable: true,
            filter: true,
          }}
          rowData={values}
        >
          <AgGridColumn
            field={"Name"}
            filter="agTextColumnFilter"
            width={250}
            headerName={t("name")}
          />
          <AgGridColumn
            field={"Symbol"}
            filter="agTextColumnFilter"
            width={150}
            headerName={t("symbol")}
          />
          <AgGridColumn
            field={"Assets"}
            filter="agTextColumnFilter"
            width={150}
            headerName={t("assets")}
          />
        </AgGridReact>
      </div>
    </div>
  );
}
